import { type AxiosResponse } from 'axios'
import { type AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'

import type {
  IParamsSavePermissions,
  IResponsePermissions,
  IResponseSavePermissions,
} from './types'

class Api {
  getPermissions(options?: AxiosOptions): Promise<AxiosResponse<IResponsePermissions>> {
    return baseApi.get('roles', { ...options })
  }

  savePermissions(
    params: IParamsSavePermissions
  ): Promise<AxiosResponse<IResponseSavePermissions>> {
    return baseApi.post('organization/permissions/save/all', { data: params })
  }
}

export const PermissionsApi = new Api()
